
import { Outlet } from "react-router-dom";

export default function CustomersLayout() {
  return (
    <Outlet />
  )
}